module.exports = __webpack_public_path__ + "img/not-happy.d6f099ba.png";